import { render, staticRenderFns } from "./ReclameAquiPercentageOfComplaintsResolved.vue?vue&type=template&id=38b97ac6&"
import script from "./ReclameAquiPercentageOfComplaintsResolved.vue?vue&type=script&lang=ts&"
export * from "./ReclameAquiPercentageOfComplaintsResolved.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports